import {
  InvalidOptionLine,
  NotOnMenuCard,
} from '../../../reducers/messagingSlice';

const SLICE_NAME = 'unresolvedItemsSlice';

// TTS message sent to the customer before the readback when the agent clicks
// "Dismiss & Repeat". Kept as a constant so it's easy to tune without digging
// through component code.
const DISMISS_REPEAT_TTS = 'Let me repeat your order so far';

// Stable identity keys used as React list keys when rendering cards.
const KEY_SEPARATOR = '␟';

const buildNotOnMenuKey = (card: Pick<NotOnMenuCard, 'item'>): string =>
  `${card.item}`;

const buildInvalidOptionKey = (
  line: Pick<InvalidOptionLine, 'option' | 'constraint' | 'is_top_level'>
): string =>
  [line.option, line.constraint ?? '', String(line.is_top_level)].join(
    KEY_SEPARATOR
  );

export {
  SLICE_NAME,
  DISMISS_REPEAT_TTS,
  buildNotOnMenuKey,
  buildInvalidOptionKey,
};
